<div class="action-menu"
     [ngClass]="{'hover': !show}"
     (click)="onClickMenu($event)">
  <i (click)="onShowMenu($event)"
     [class]="'hover fa ' + iconName"></i>
     @if(show){
       <ng-container>
         <div class="outside-background transparent"
              (click)="onClickOutside($event)"></div>
         <div class="action-menu-container card padding-small"
              (click)="onClickMenu($event)"
              [ngStyle]="{
                'top': top === undefined ? null : (top + 'px'),
                'right': right === undefined ? null : (right + 'px'),
                'bottom': bottom === undefined ? null : (bottom + 'px'),
                'left': left === undefined ? null : (left + 'px')
               }">
           <ng-content></ng-content>
         </div>
       </ng-container>
     }
</div>
